import {AfterViewInit, Directive, ElementRef, HostListener} from '@angular/core';
import {timeout} from "../decorators/timeout";

@Directive({selector: '[spinning]'})
export class SpinningDirective implements AfterViewInit {

    spun = 0;

    @HostListener('click', ['$event']) onClick($event){
        this.spin();
    }

    constructor(private host: ElementRef) {
    }

    ngAfterViewInit() {
        // setTimeout(() => this.host.nativeElement.focus());
    }

    @timeout(500)
    spin() {
        this.spun += 720;
        const a = this.host.nativeElement.querySelector('.spinning');
        a.style.transform = 'rotate(' + this.spun + 'deg)';
    }
}
